import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RecetaEditCreateComponent } from './receta-edit-create/receta-edit-create.component';
import { Recipes } from 'app/models/receta.models';
import { RecetaService } from 'app/services/receta.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { MeasurementUnit } from 'app/models/umedida.models';
import { UmedidaService } from 'app/services/umedida.service';

@Component({
  selector: 'app-recetas',
  templateUrl: './recetas.component.html',
  styleUrls: ['./recetas.component.css'],
})
export class RecetasComponent {
  recetas: Recipes[] = [];
  unidades: MeasurementUnit[] = [];

  constructor(
    public dialog: MatDialog,
    private recetaService: RecetaService,
    private unidadService: UmedidaService,
    private snackBar: MatSnackBar
  ) {
    this.getRecetas();
  }

  ngOnInit() {
    this.getUnidades();
  }

  getRecetas() {
    this.recetas = [];
    this.recetaService.getRecetas().subscribe(
      (data: Recipes[]) => {
        this.recetas = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  getUnidades() {
    this.unidadService.getUmedidas().subscribe(
      (data: MeasurementUnit[]) => {
        this.unidades = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  abrirDialogo() {
    const dialogRef = this.dialog.open(RecetaEditCreateComponent, {
      width: '55%',
      disableClose: true,
      data: {
        unidades: this.unidades,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getRecetas();
      }
    });
  }

  eliminarReceta(receta: Recipes) {
    Swal.fire({
      title: 'Advertencia',
      text: '¿Seguro que desea eliminar la receta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
    }).then(result => {
      if (result.value) {
        this.recetaService.deleteReceta(receta.id).subscribe(
          (data: any) => {
            console.log(data);
            this.openSnackBar(`Receta eliminada correctamente.`, 'Información');
            this.getRecetas();
          },
          error => {
            console.error(error);
            this.openSnackBar(`Ocurrió un error al eliminar la receta`, 'Error');
          }
        );
      }
    });
  }
  editarReceta(receta: Recipes) {
    console.log({ receta });
    const dialogRef = this.dialog.open(RecetaEditCreateComponent, {
      width: '80%',
      disableClose: true,
      data: {
        receta: receta,
        unidades: this.unidades,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getRecetas();
      }
    });
  }

  openSnackBar(message: string, type) {
    this.snackBar.open(message, type, {
      duration: 5000,
    });
  }
}
